export interface ValidationResult {
  isValid: boolean;
  errorMessage: string;
}

export const validateEmail = (email: string): ValidationResult => {
  if (!email || !email.trim()) {
    return { isValid: false, errorMessage: '이메일을 입력해주세요.' };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid = emailRegex.test(email);

  return {
    isValid,
    errorMessage: isValid ? '' : '올바른 이메일 형식을 입력해주세요.',
  };
};
